import { createAction, props } from '@ngrx/store';

export const getCards = createAction('[Cards] Get cards', props<any>());
export const cardsFailure = createAction('[Cards] Cards failed', props<any>());
export const cardsSuccess = createAction('[Cards] Cards sucess', props<any>());
